module.exports = __webpack_public_path__ + "static/media/wab32_1013.0be036f5.ico";